@use "variables" as *;

.icon {
  font-size: $fontSize-l;
}
